import { observer } from "mobx-react";
import _ from "lodash";
import { Button } from "react-bootstrap";
import { useEffect, useState } from "react";
import { useStores } from "../../stores/root-store";
import AddOnOptsListing from "./addOnOpts-listing";
import AddOnOptForm from "./addOnOpt-form";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";

const ManageAddOnOpts = observer(() => {
  const { addOnOptstore } = useStores();
  const { editAddOnOption, setEditAddOnOption } = addOnOptstore;
  const [showAddOnOptsForm, setShowAddOnOptsForm] = useState(false);

  const handleAddOnOptsFormClose = (show: boolean) => {
    setShowAddOnOptsForm(show);
    if (!show) setEditAddOnOption(null);
  };

  useEffect(() => {
    if (editAddOnOption)
      setShowAddOnOptsForm(editAddOnOption.addOnOptionId > 0);
  }, [editAddOnOption]);

  return (
    <div className="mt-3 pb-3">
      <div className="row mb-3">
        <h5 className="mb-0 text-start">
          Add-On Options
          <Button
            onClick={() => setShowAddOnOptsForm(true)}
            className="btn-default float-end"
          >
            <FontAwesomeIcon icon={faPlus} className="me-2" />
            Add New
          </Button>
        </h5>
      </div>
      <AddOnOptsListing />
      {showAddOnOptsForm && (
        <AddOnOptForm
          show={showAddOnOptsForm}
          setShowModal={handleAddOnOptsFormClose}
        />
      )}
    </div>
  );
});

export default ManageAddOnOpts;
